module.exports = __webpack_public_path__ + "img/38_21.f91b9017.png";